'use strict';

module.exports = {
    PRODUCTION: 'production',
    STAGING: 'staging',
    NODE: 'node'
};


//////////////////
// WEBPACK FOOTER
// ./~/watch-scorekeeper/dist/ScorekeeperEnvironments.js
// module id = 320
// module chunks = 0